import { Table } from "antd";
import styled from "styled-components";
import color from "../_style/color";

export default styled(Table)
  .withConfig({
    shouldForwardProp: (prop) => !["rowBorder", "headerBorder", "footerBorder"].includes(prop),
  })
  .attrs((props) => ({
    pagination: props.pagination || false,
    rowBorder: props.rowBorder || false,
    headerBorder: props.headerBorder || false,
    footerBorder: props.footerBorder || false,
    padding: props.padding,
  }))`
  padding: ${({ padding }) => padding};

  .ant-table-cell {
    padding: unset;
    border-bottom: ${({ rowBorder }) =>
      rowBorder ? `1px solid ${color.gainsboro}` : "unset"} !important;
  }
  
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td {
    border-bottom: 1px solid ${color.gainsboro};
  }

  .ant-table-tbody > tr:last-child > td {
    border-bottom: ${({ footerBorder }) =>
      footerBorder ? `1px solid ${color.gainsboro}` : "unset"} !important;
  }

  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: unset;
  }

  .ant-table-thead > tr > th {
    background-color: ${color.light};
    border-bottom: ${({ headerBorder }) =>
      headerBorder ? `1px solid ${color.gainsboro}` : "unset"} !important;
  }

  .ant-table.ant-table-bordered thead > tr > th,
  .ant-table.ant-table-bordered tbody > tr > td,
  .ant-table.ant-table-bordered tfoot > tr > th,
  .ant-table.ant-table-bordered tfoot > tr > td {
    border-right: 1px solid ${color.gainsboro};
  }

  .ant-table.ant-table-bordered .ant-table-container {
    border: 1px solid ${color.gainsboro};
    border-right: 0;
    border-bottom: 0;
  }
`;
